import script from "./MarketplaceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketplaceHeader.vue?vue&type=script&setup=true&lang=js"

import "./MarketplaceHeader.vue?vue&type=style&index=0&id=3566604d&scoped=true&lang=scss"
import "./MarketplaceHeader.vue?vue&type=style&index=1&id=3566604d&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3566604d"]])

export default __exports__